import type { StatsChartData } from './statsTypes';
import type { StatItem } from './StatBlock';

/**
 * #673 — convert the same StatsChartData arrays that feed the charts into
 * copyable StatBlock items, so the numbers are guaranteed to match the graphs.
 */
export function toStatItems(
    data: StatsChartData[],
    format?: (n: number) => string | number
): StatItem[] {
    return data.map(d => ({ label: d.name, value: format ? format(d.value) : d.value }));
}

/** Hectares are rounded and thousands-separated, matching the To-Date block. */
export const asHectares = (n: number): string => Math.round(n).toLocaleString();
